






































































































































































import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import { ProjectDetailFooter } from '@/model/project/ProjectDetailFooter'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import DxDataGrid from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProjectDetailForm from '@/components/project/ProjectDetailForm.vue'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import {
  EDIT_PROJECT,
  PROJECT_ASSISTANT_FETCH_START,
  SET_PROJECT_LOCK_STATUS
} from '@/store/action-types'
import {
  CodeBezeichnungItem,
  EmployeeInfoItem,
  ResponseBase,
  StartAssistantResponse,
  WertIdBezeichnungItem
} from '@/types/service-response'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { UpdateProjectPayload } from '@/types/payload'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  splitHeight: string
  pane1Size: number
  pane2Size: number
  pane2Height: string
  isSplitterOpen: boolean

  profitCenterList: CodeBezeichnungItem[]
  lieferungList: CodeBezeichnungItem[]
  zahlungList: CodeBezeichnungItem[]
  versandList: CodeBezeichnungItem[]
  eingangviaList: WertIdBezeichnungItem[]
  sachbearbeiterList: EmployeeInfoItem[]

  formIsValid: boolean
  validationRules: Array<Function>
  address: string
  profitCenter: number | null
  profitCenterBezeichnung: any | undefined
  prozess: any | undefined
  select2List: any
  projektNummer: string
  eingangvia: number | null
  eingangviaBezeichnung: any | undefined
  select3List: any
  unsereReferenz: number | null
  unsereReferenzVollerName: any | undefined
  select4List: any
  sachbearbeiter: number | null
  sachbearbeiterVollerName: any | undefined
  commissionLabel: any | undefined
  select5List: any
  titel: string
  ihreReferenz: string
  lieferung: number | null
  lieferkonditionBezeichnung: any | undefined
  zahlung: number | null
  zahlungskonditionBezeichnung: any | undefined
  select7List: any
  versand: number | null
  versandBezeichnung: any | undefined
  select8List: any
  select9: any | undefined
  select9List: any
  select10: any | undefined
  select10List: any
  menu1: boolean
  menu2: boolean
  projectDate: string | null
  projectDateFormatted: string | null
  referenceDate: string | null
  referenceDateFormatted: string | null
  dateRules: any[]
  showSearchDialog: boolean

  erfassung: string
  netto: string
  steuer: string
  total: string

  gesperrt: boolean
  gesperrtVonName: string

  loadingEdit: boolean
}

export default Vue.extend({
  name: 'ProjectForm',

  components: {
    ProjectDetailForm,
    ProjectAddressSearch,
    DxDataGrid,
    Splitpanes,
    Pane
  },

  props: {
    projectId: Number,
    projectDetail: Array as () => ProjectDetail[],
    projectDetailHeader: Object as () => ProjectDetailHeader,
    projectDetailFooter: Object as () => ProjectDetailFooter,
    isCreateProject: Boolean,
    isEditProject: Boolean,
    selectedProjectId: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('project.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      splitHeight: 'height: 695px',
      pane1Size: 100,
      pane2Size: 0,
      pane2Height: '',
      isSplitterOpen: false,

      profitCenterList: [],
      lieferungList: [],
      zahlungList: [],
      versandList: [],
      eingangviaList: [],
      sachbearbeiterList: [],

      formIsValid: false,
      validationRules: [required],
      address: '',
      profitCenter: null,
      profitCenterBezeichnung: '',
      prozess: undefined,
      select2List: [],
      projektNummer: '',
      eingangvia: null,
      eingangviaBezeichnung: undefined,
      select3List: [],
      unsereReferenz: null,
      unsereReferenzVollerName: undefined,
      select4List: [],
      sachbearbeiter: null,
      sachbearbeiterVollerName: undefined,
      commissionLabel: undefined,
      select5List: [],
      titel: '',
      ihreReferenz: '',
      lieferung: null,
      lieferkonditionBezeichnung: undefined,
      zahlung: null,
      zahlungskonditionBezeichnung: undefined,
      select7List: [],
      versand: null,
      versandBezeichnung: undefined,
      select8List: [],
      select9: undefined,
      select9List: [],
      select10: undefined,
      select10List: [],
      menu1: false,
      menu2: false,
      projectDate: '',
      projectDateFormatted: '',
      referenceDate:'',
      referenceDateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        },
      ],
      showSearchDialog: false,

      erfassung: '',
      netto: '',
      steuer: '',
      total: '',

      gesperrt: false,
      gesperrtVonName: '',

      loadingEdit: false
    }
  },

  watch: {
    isCreateProject (newVal: boolean) : void {
      if(newVal) {
        this.setHeader()
        this.setFooter()
        const form: any = this.$refs['form']
        form.resetValidation()
      } else {
        this.setHeader(this.projectDetailHeader)
        this.setFooter(this.projectDetailFooter)
        const form: any = this.$refs['form']
        form.resetValidation()
      }
    },

    projectDetailHeader (newVal: ProjectDetailHeader): void {
      if(newVal) {
        this.setHeader(newVal)
      }
    },

    projectDetailFooter (newVal: ProjectDetailFooter): void {
      if(newVal) {
        this.setFooter(newVal)
      }
    },

    projectDateFormatted (newVal: string): void {
      if(newVal) {
        this.projectDate = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.projectDate = ''
      }
    },

    referenceDateFormatted (newVal: string): void {
      if(newVal) {
        this.referenceDate = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.referenceDate = ''
      }
    },

    isEditMode (newVal: boolean): void {
      if(newVal) {
        this.onResize()
      } else {
        this.onResize()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEditMode (): boolean {
      if(this.isCreateProject || this.isEditProject) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
      return this.isCreateProject || this.isEditProject
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    formatNumber(value: number | null, digital: number): any {
      if(value !== null) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },

    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onSelectedAddress (data: SearchAddress): void {
      this.showSearchDialog = false
      this.address = data.genAdresse
      //this.selectedAddressId = data.id
    },

    onProjectDateChange (date: string): void {
      this.projectDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onReferenceDateChange (date: string): void {
      this.referenceDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurProject (): void {
      this.projectDateFormatted = this.projectDate && moment(this.projectDate).isValid() ? moment(this.projectDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurReference (): void {
      this.referenceDateFormatted = this.referenceDate && moment(this.referenceDate).isValid() ? moment(this.referenceDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    setHeader (data?: ProjectDetailHeader): void {
      this.address = data ? data.AdressFeld.replace(/\n/g, "<br />") : ''
      this.profitCenter = data && parseInt(data.ProfitCenter) ? parseInt(data.ProfitCenter) : null
      this.profitCenterBezeichnung = data ? data.ProfitCenterBezeichnung : ''
      this.prozess = data ? data.ProzessArtBezeichnung : undefined
      this.projektNummer = data ? data.Nummer : ''
      this.eingangvia = data && parseInt(data.EingangViaWert) ? parseInt(data.EingangViaWert) : null
      this.eingangviaBezeichnung = data ? data.EingangViaBzg : undefined
      this.unsereReferenz = data && parseInt(data.UnsereReferenz) ? parseInt(data.UnsereReferenz) : null
      this.unsereReferenzVollerName = data ? data.UnsereReferenzNameK : undefined
      this.sachbearbeiter = data && parseInt(data.Sachbearbeiter) ? parseInt(data.Sachbearbeiter) : null
      this.sachbearbeiterVollerName = data ? data.SachbearbeiterNameK : undefined
      this.commissionLabel = data && data.KommissionNummer && data.KommissionBezeichnung ? `${data.KommissionNummer} - ${data.KommissionBezeichnung}` : undefined

      this.titel = data ? data.Titel : ''
      this.ihreReferenz = data ? data.IhreReferenz : ''
      this.lieferung = data && parseInt(data.Lieferkondition) ? parseInt(data.Lieferkondition) : null
      this.lieferkonditionBezeichnung = data ? data.LieferkonditionBezeichnung : undefined
      this.zahlung = data && parseInt(data.Zahlungskondition) ? parseInt(data.Zahlungskondition) : null
      this.zahlungskonditionBezeichnung = data ? data.ZahlungskonditionBezeichnung : undefined
      this.versand = data && parseInt(data.Versandart) ? parseInt(data.Versandart) : null
      this.versandBezeichnung = data ? data.VersandartBezeichnung : undefined

      this.referenceDate = data ? moment(data.ReferenzTermin).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      this.referenceDateFormatted = data ? moment(data.ReferenzTermin).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY')
      this.projectDate = data ? moment(data.ProjektDatum).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      this.projectDateFormatted = data ? moment(data.ProjektDatum).format('DD.MM.YYYY') : moment().format('DD.MM.YYYY')

      this.gesperrt = data && data.Gesperrt === 'True' ? true : false
      this.gesperrtVonName = data ? data.GesperrtVonNameK : ''
    },

    setFooter (data?: ProjectDetailFooter): void {
      this.erfassung = ''
      this.netto = data ? this.formatNumber(data.Netto, 2) : ''
      this.steuer = data ? this.formatNumber(data.Steuer, 2) : ''
      this.total = data ? this.formatNumber(data.Total, 2) : ''
    },

    async onProjectLockStatusChange (item: boolean): Promise<void> {
      const payload: any = {
        projectId: this.projectId,
        value: item ? 1 : 0
      }

      try {
        const response: ResponseBase = await this.$store.dispatch(SET_PROJECT_LOCK_STATUS, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.$emit('updateData')
      }
    },

    onCancelProjectHeaderClick (): void {
      this.setHeader(this.projectDetailHeader)
      this.$emit('onCancelProjectHeaderClick')
    },

    onSaveProjectHeaderClick (): void {
      if(this.isCreateProject) {
        this.$emit('onCreated', 0)
      } else if(this.isEditProject) {
        const form: any = this.$refs['form']
        if (form.validate()) {
          this.updateProject()
        }
      }
    },

    createdDetail (): void {
      this.$emit('createdDetail')
    },

    updatedDetail (): void {
      this.$emit('updatedDetail')
    },

    deletedDetail(item: ProjectDetail): void {
      this.$emit('deletedDetail', item)
    },

    async updateProject (): Promise<void> {
      this.$emit('onEditLoading', true)
      const payload: UpdateProjectPayload = {
        ID: this.projectId,
        Titel: this.titel,
        Profitcenter: this.profitCenter!,
        Sachbearbeiter: this.sachbearbeiter!,
        UnsereReferenz: this.unsereReferenz!,
        IhreReferenz: this.ihreReferenz,
        Lieferkondition: this.lieferung!,
        Zahlungskondition: this.zahlung!,
        Versandart: this.versand!,
        ReferenzTermin: this.referenceDate!,
        ProjektDatum: this.projectDate!,
        EingangVia: this.eingangvia,
        Kommission: null
      }

      try {
        this.loadingEdit = true
        const response: any = await this.$store.dispatch(EDIT_PROJECT, payload)
        this.loadingEdit = false
        this.$emit('onEditLoading', false)
        if(!response.IsError) {

          this.$emit('onEdited')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.$emit('onEditLoading', false)
        this.loadingEdit = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      try {
        const response: StartAssistantResponse = await this.$store.dispatch(PROJECT_ASSISTANT_FETCH_START)
        if(!response.IsError) {
          this.profitCenterList = response.ProfitCenter
          this.lieferungList = response.Lieferung
          this.zahlungList = response.Zahlung
          this.versandList = response.Versand
          this.eingangviaList = response.Eingangvia
          this.sachbearbeiterList = response.Sachbearbeiter
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    splitterDoubleClick (e: any): void {
      if(this.isSplitterOpen) {
        setTimeout(() => {
          const vh = window.innerHeight
          const height = 225
          if(this.isEditMode) {
            this.pane1Size = (100 * 427) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 360) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        }, 0)
      } else {
        setTimeout(() => {
          this.pane1Size = 0
          this.pane2Size = 100
          this.resizedSplitter(null)
        }, 0)
      }

      this.isSplitterOpen = !this.isSplitterOpen
    },

    resizedSplitter (item: any): void {
      setTimeout(() => {
        const pane2: any = this.$refs['pane2']
        this.pane2Height = `${pane2.$el.clientHeight - 96}px`
      }, 300)
    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 695) {
        const height = 225
        if((vh - height) > 200) {
          this.splitHeight = `height: calc(${vh}px - ${height}px)`
          if(this.isEditMode) {
            this.pane1Size = (100 * 427) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 360) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        } else {
          this.splitHeight = 'height: 695px'
          if(this.isEditMode) {
            this.pane1Size = (100 * 427) / 695
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 360) / 695
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        }
      } else {
        this.splitHeight = 'height: 695px'
        if(this.isEditMode) {
          this.pane1Size = (100 * 427) / 695
          this.pane2Size = 100 - this.pane1Size
          this.resizedSplitter(null)
        } else {
          this.pane1Size = (100 * 360) / 695
          this.pane2Size = 100 - this.pane1Size
          this.resizedSplitter(null)
        }
      }
    }
  },

  mounted () {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter!.addEventListener("dblclick", this.splitterDoubleClick)
    }

    if(this.projectDetailHeader) {
      this.setHeader(this.projectDetailHeader)
    }
    if(this.projectDetailFooter) {
      this.setFooter(this.projectDetailFooter)
    }
    this.fetchData()
  },

  beforeDestroy() {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter.removeEventListener("dblclick", this.splitterDoubleClick)
    }
  },
})
